import React, { useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';

const TextEntryAnswer = (props) => {
    const divRef = useRef(null);
    const q = props.question;
    const id = q.questionID;

    useEffect(() => {
        if (divRef.current) {
            const label = divRef.current.querySelector('label');
            const input = divRef.current.querySelector('input');
            if (label && !label.getAttribute('id')) {
                label.setAttribute('id', q.question.alias || `q-${id}`);
            }
            if (input && !input?.getAttribute('aria-labelledby')) {
                input.setAttribute('aria-labelledby', q.question.alias || `q-${id}`);
            }
        }
    });

    // <p className={props.disabled ? 'questionnaire-body disabled' : 'questionnaire-body'}>{q.question}</p>
    return (
        <div key={`q${id}`} ref={divRef}>
            <InputLabel className="questionnaire-body">
                <p>{q.question}</p>
                <TextField
                    label={props.inputLabel}
                    disabled={props.disabled}
                    type="text"
                    className="questionnaire-body"
                    name={`a${id}`}
                    error={props.error}
                    onChange={(e) => {
                        props.responseHandler(id, e.target.value, e);
                    }}
                    onBlur={() => {
                        props.validateField();
                    }}
                    InputProps={{
                        className: 'questionnaire-body'
                    }}
                    helperText={props.helperText}
                    value={q.response.responseText || ''}
                />
            </InputLabel>
        </div>
    );
};

export default TextEntryAnswer;
